import { Validator } from '@vista-digital/validator';
import { defaultSeatPickerNotificationConfig } from '../../../../../seat-picker/types/config/notification';
import { seatPickerEventsValidator } from '../../../../../seat-picker/types/events';
import { defaultSwapSeatPickerConfig, swapSeatPickerConfigValidator } from '../../../../../swap-seat-picker/types/config';
import { JourneyActionButtonType } from '../../../types/type';
import { defaultJourneyActionButtonSwapSeatsAssets, journeyActionButtonSwapSeatsAssetsValidator } from './assets';
import { defaultJourneyActionButtonSwapSeatsDisplayText, journeyActionButtonSwapSeatsDisplayTextValidator } from './display-text';
export const defaultJourneyActionButtonSwapSeatsProps = {
    type: JourneyActionButtonType.SwapSeats,
    displayText: defaultJourneyActionButtonSwapSeatsDisplayText,
    assets: defaultJourneyActionButtonSwapSeatsAssets,
    config: Object.assign(Object.assign({}, defaultSwapSeatPickerConfig), { notification: Object.assign(Object.assign({}, defaultSeatPickerNotificationConfig), { displayInline: false }) }),
    events: {}
};
export const journeyActionButtonSwapSeatsPropsValidator = Validator.object({
    type: Validator.isEqualTo(JourneyActionButtonType.SwapSeats),
    displayText: journeyActionButtonSwapSeatsDisplayTextValidator,
    assets: journeyActionButtonSwapSeatsAssetsValidator,
    config: swapSeatPickerConfigValidator,
    events: seatPickerEventsValidator
});
